<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-10-10 13:52:52
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-14 17:31:42
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss" scoped>
  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;
  }
</style>
